import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import { captureAttribution } from './lib/attribution';
import './styles/global.css';

// 流入元（utm）をルーティング前に保存（H3）
captureAttribution();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
